import { isCreditCardCategory, isCarCategory } from 'lib/baufi/helper';

export const MAX_CREDITCARD_AMOUNT = 750;

export const isCreditCardRedirect = (
  category: number | string,
  amountAsInt: number,
) => {
  return (
    isCreditCardCategory(category) ||
    (amountAsInt <= MAX_CREDITCARD_AMOUNT && !isCarCategory(category))
  );
};
